import { useFormat } from 'helpers/hooks/useFormat';
import { useProductList } from '../../context';

interface Props {
  query: string;
}

const SearchHeader: React.FC<Props> = ({ query }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { totalItems } = useProductList();

  if (!query) return <></>;

  return (
    <div>
      <h1 className="font-body text-[18px] md:text-[26px] lg:text-[28px]">
        {formatMessage({
          id: 'search.resultsFor',
          defaultMessage: 'Risultati per',
        })}{' '}
        <span className="font-medium">“{query}”</span>
      </h1>
      <h4 className="mt-6 font-body text-[14px] md:text-[16px]">
        {formatMessage({
          id: 'search.resultsFound',
          defaultMessage: '{count} risultati trovati',
          values: { count: totalItems },
        })}
      </h4>
    </div>
  );
};

export default SearchHeader;
